// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zvGBDWK62rwZoieqZWfw{gap:8px;width:-webkit-fit-content;width:fit-content;padding-top:3px;display:flex}.zvGBDWK62rwZoieqZWfw>div:nth-last-child(2) [data-name=attachmentRemovable] button{right:-1px}.Q9XChrCQFoeGbu68aHf3{margin-bottom:8px}.Q9XChrCQFoeGbu68aHf3 ._dimHea8AfR6qClXTu9s{display:none}.Q9XChrCQFoeGbu68aHf3 [data-name=attachmentCard],.Q9XChrCQFoeGbu68aHf3 [data-name=attachmentRemovable]{background-color:var(--background-neutral-default)}.Q9XChrCQFoeGbu68aHf3 [data-name=attachmentRemovable]:after{display:none}._dimHea8AfR6qClXTu9s{width:4px}.iPvcokqIfCQPXlnv6six{margin-bottom:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": `zvGBDWK62rwZoieqZWfw`,
	"isUnderline": `Q9XChrCQFoeGbu68aHf3`,
	"box4": `_dimHea8AfR6qClXTu9s`,
	"alertContainer": `iPvcokqIfCQPXlnv6six`
};
export default ___CSS_LOADER_EXPORT___;
